function setMaxHeight() {
    var wrapperHeight = $('.featured-slider .swiper-wrapper img').height();
    // console.log(wrapperHeight);
    $('.featured-slider .image-container').css('height', wrapperHeight);
}

function applyPaddingLeft() {
    // Retreive spacing from left of logo and update slideshow slide-info
    var paddingLeft = $('.site-branding').offset().left;
    // console.log(paddingLeft);
    $('.slide-info').css('left', paddingLeft);
}

// Call the function on document ready
$(document).ready(function() {
    // setMaxHeight();
    // applyPaddingLeft();
});

// Call the function on window resize
$(window).resize(function() {
    // setMaxHeight();
    // applyPaddingLeft();
});